<template>

  <app-content class="frame-page" >
      <div class="markdown-body" >
        <changelog />
      </div>

  </app-content>
</template>
<script>
  import {mapMutations, mapState} from 'vuex';
  import changelog from './CHANGELOG.md'
  import 'github-markdown-css/github-markdown-light.css';

  export default {
    name: 'ChangeLog',
    components: {
      changelog
    },
    data() {
      return {
        ver:""
      };
    },
    computed: {
      ...mapState(['currentAccountSets', 'currentTab']),

    },
    methods: {
      ...mapMutations(['newTab']),

      init() {
        this.changelogContent = changelog
        }
      },
    created() {
      this.init();
    },
    mounted() {
    }
  };
</script>

<style>
.markdown-body{
  padding:20px;
}
.markdown-body ul{
  list-style: initial;
}

</style>

